export const NAVIGATE_TO_PAGE = 'NAVIGATE_TO_PAGE';
export const CLICK_CHANGE_VEHICLE_LINK = 'CLICK_CHANGE_VEHICLE_LINK';
export const CLICK_CHANGE_TRADEIN_VEHICLE_LINK = 'CLICK_CHANGE_TRADEIN_VEHICLE_LINK';
export const CLICK_CHANGE_ZIPCODE_LINK = 'CLICK_CHANGE_ZIPCODE_LINK';
